import React from "react";
import classnames from "classnames";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";

import GooglePng from "../../assets/media/analytics/google.png";

import ActiveUser from "../../assets/media/analytics_icons/active_user.png";
import EcoId from "../../assets/media/analytics_icons/eco_id.png";
import UserReviews from "../../assets/media/analytics_icons/user_reviews.png";
import ActiveOpenBankingUsers from "../../assets/media/analytics_icons/open_banking.png";
import TokenValueEarned from "../../assets/media/analytics_icons/token_value_earned.png";
import TokenValueRedeemed from "../../assets/media/analytics_icons/token_value_redeemed.png";
import PollAnswers from "../../assets/media/analytics_icons/poll_answers.png";
import ForumEngagement from "../../assets/media/analytics_icons/forum_engagement.png";
import TicketOpened from "../../assets/media/analytics_icons/tickets_opened.png";
import TicketClosed from "../../assets/media/analytics_icons/tickets_closed.png";
import UserReferrals from "../../assets/media/analytics_icons/user_referrals.png";
import TokenSpendingMarketplace from "../../assets/media/analytics_icons/token_spending_marketplace.png";

import "./index.css";
import { CurrencyOptions, TerritoryOptions } from "../../Constants/retailer";
import { nFormatter } from "../../Utils/utils";

// NOTE: for static purpose
const BrandAnalytics = (territory, values, key) =>
  ({
    active_users: {
      icon: ActiveUser,
      text: "Active\nusers",
      value: values[key] || 0,
    },
    verified_eco_ids: {
      icon: EcoId,
      text: "Verified\nEcoIDs",
      value: values[key] || 0,
    },
    user_reviews: {
      icon: UserReviews,
      text: (
        <span>
          User reviews
          <br />
          <img
            src={GooglePng}
            alt="icon"
            style={{ height: 22, marginBottom: 0 }}
          />
        </span>
      ),
      value: values[key] || 0,
    },
    active_open_banking: {
      icon: ActiveOpenBankingUsers,
      text: "Active open\nbanking users",
      value: values[key] || 0,
    },
    token_value_earned: {
      icon: TokenValueEarned,
      text: "Token value\nearned",
      value: `${CurrencyOptions[territory]}${values[key] || 0}`,
    },
    token_value_redeemed: {
      icon: TokenValueRedeemed,
      text: "Token value\nredeemed",
      value: `${CurrencyOptions[territory]}${values[key] || 0}`,
    },
    poll_answers: {
      icon: PollAnswers,
      text: "Poll\nanswers",
      value: values[key] || 0,
    },
    forum_engagement: {
      icon: ForumEngagement,
      text: "Forum\nengagements",
      value: values[key] || 0,
    },
    tickets_opened: {
      icon: TicketOpened,
      text: "Tickets\nopened",
      value: values[key] || 0,
    },
    tickets_closed: {
      icon: TicketClosed,
      text: "Tickets closed\nsuccessfully",
      value: values[key] || 0,
    },
    user_referrals: {
      icon: UserReferrals,
      text: "User\nreferrals",
      value: values[key] || 0,
    },
    token_spending_marketplace: {
      icon: TokenSpendingMarketplace,
      text: "Total spending\nin marketplace",
      value: `${CurrencyOptions[territory]}${values[key] || 0}`,
    },
  }[key]);

const EcoAnalytics = (territory) => ({
  active_users: {
    icon: ActiveUser,
    text: "Active\nusers",
    value: "54,421",
  },
  verified_eco_ids: {
    icon: EcoId,
    text: "Verified\nEcoIDs",
    value: "12,312",
  },
  user_reviews: {
    icon: UserReviews,
    text: (
      <span>
        User reviews
        <br />
        <img
          src={GooglePng}
          alt="icon"
          style={{ height: 22, marginBottom: 0 }}
        />
      </span>
    ),
    value: "7,765",
  },
  active_open_banking: {
    icon: ActiveOpenBankingUsers,
    text: "Active open\nbanking users",
    value: 765,
  },
  token_value_earned: {
    icon: TokenValueEarned,
    text: "Token value\nearned",
    value: `${CurrencyOptions[territory]}2.28m`,
  },
  token_value_redeemed: {
    icon: TokenValueRedeemed,
    text: "Token value\nredeemed",
    value: `${CurrencyOptions[territory]}1.76m`,
  },
  poll_answers: {
    icon: PollAnswers,
    text: "Poll\nanswers",
    value: "62,331",
  },
  forum_engagement: {
    icon: ForumEngagement,
    text: "Forum\nengagements",
    value: "10,216",
  },
  tickets_opened: {
    icon: TicketOpened,
    text: "Tickets\nopened",
    value: "2,032",
  },
  tickets_closed: {
    icon: TicketClosed,
    text: "Tickets closed\nsuccessfully",
    value: "1,735",
  },
  user_referrals: {
    icon: UserReferrals,
    text: "User\nreferrals",
    value: 275,
  },
  token_spending_marketplace: {
    icon: TokenSpendingMarketplace,
    text: "Total spending\nin marketplace",
    value: `${CurrencyOptions[territory]}567k`,
  },
});

class Analytics extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      brandTab: 0,
      ecoTab: 0,
      territory: TerritoryOptions[0],
      brandAnalytics: {
        active_users: 0,
        poll_answers: 0,
        token_value_earned: 0,
        user_referrals: 0,
      },
    };
  }

  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand, loading: true });
      Firebase.getBrandDataByID(brand, (res) => {
        this.setState({
          logo: res.logo,
          icon: res.icon,
          brand_name: res.name,
          brand_url: res.url,
          hex: res.hex,
          loading: false,
          is_property_brand: res.is_property_brand
            ? res.is_property_brand
            : false,
          programme: res.programme || {
            community: {
              active: true,
              price: 0,
            },
            concierge: {
              active: true,
              price: 0,
            },
            renter: {
              active: true,
              price: 0,
            },
          },
          territory: res.territory || TerritoryOptions[0],
        });

        // Update brand active users
        Firebase.getAllUsers(res.name, (res) => {
          const usersStatistic = res.reduce(
            (prev, cur) => ({
              pollAnswers: prev.pollAnswers + (cur.poll_answers || []).length,
              tokenValueEarned: prev.tokenValueEarned + (cur.tokens || 0),
              userReferrals: prev.userReferrals + (cur.friends || []).length,
            }),
            { pollAnswers: 0, tokenValueEarned: 0, userReferrals: 0 }
          );
          const brandAnalytics = { ...this.state.brandAnalytics };
          brandAnalytics["active_users"] = res.length;
          brandAnalytics["verified_eco_ids"] = res.filter(
            (user) => user.eco_id
          ).length;
          brandAnalytics["poll_answers"] = nFormatter(
            usersStatistic.pollAnswers,
            0
          );
          brandAnalytics["token_value_earned"] = nFormatter(
            usersStatistic.tokenValueEarned / 100,
            2
          );
          brandAnalytics["user_referrals"] = nFormatter(
            usersStatistic.userReferrals,
            0
          );
          this.setState({ brandAnalytics });
        });
      });
    }
  }

  onTabChanged = (name, value) => () => {
    this.setState({
      [name]: value,
    });
  };

  renderItem = (item) => (
    <div className="item-container">
      <img src={item.icon} alt="icon" />
      <p className="item-name">{item.text}</p>
      <p className="item-value">{item.value}</p>
    </div>
  );

  render() {
    const {
      username,
      role,
      logo,
      brand,
      is_property_brand,
      loading,
      brand_name,
      brandTab,
      ecoTab,
      territory,
    } = this.state;
    return (
      <div id="page-contaienr">
        <Header
          username={username}
          role={role}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <main id="main-container">
          <div className="analytics-content">
            {loading && (
              <div className="loading">
                <i className="fa fa-4x fa-sync fa-spin text-muted" />
              </div>
            )}
            {!loading && (
              <div className="analytics-container">
                <div className="brand-anlaytics">
                  <div className="analytics-header">
                    <div className="analytics-header-title">
                      <h4>
                        Access your full community control center on tablet,
                        laptop or PC.
                      </h4>
                      <p>{brand_name}'s Analytics</p>
                    </div>
                    <div className="mode-btn-group">
                      <div
                        className={classnames("mode-toggle-btn", {
                          selected: brandTab === 0,
                        })}
                        onClick={this.onTabChanged("brandTab", 0)}
                      >
                        Total
                      </div>
                      <div
                        className={classnames("mode-toggle-btn", {
                          selected: brandTab === 1,
                        })}
                      >
                        This month
                      </div>
                      <div
                        className={classnames("mode-toggle-btn", {
                          selected: brandTab === 2,
                        })}
                      >
                        Today
                      </div>
                    </div>
                  </div>
                  <div className="items-container">
                    {this.renderItem(
                      BrandAnalytics(
                        territory,
                        this.state.brandAnalytics,
                        "active_users"
                      )
                    )}
                    {this.renderItem(
                      BrandAnalytics(
                        territory,
                        this.state.brandAnalytics,
                        "verified_eco_ids"
                      )
                    )}
                    {this.renderItem(
                      BrandAnalytics(
                        territory,
                        this.state.brandAnalytics,
                        "user_reviews"
                      )
                    )}
                    {this.renderItem(
                      BrandAnalytics(
                        territory,
                        this.state.brandAnalytics,
                        "active_open_banking"
                      )
                    )}
                  </div>
                  <div className="items-container">
                    {this.renderItem(
                      BrandAnalytics(
                        territory,
                        this.state.brandAnalytics,
                        "token_value_earned"
                      )
                    )}
                    {this.renderItem(
                      BrandAnalytics(
                        territory,
                        this.state.brandAnalytics,
                        "token_value_redeemed"
                      )
                    )}
                    {this.renderItem(
                      BrandAnalytics(
                        territory,
                        this.state.brandAnalytics,
                        "poll_answers"
                      )
                    )}
                    {this.renderItem(
                      BrandAnalytics(
                        territory,
                        this.state.brandAnalytics,
                        "forum_engagement"
                      )
                    )}
                  </div>
                  <div className="items-container">
                    {this.renderItem(
                      BrandAnalytics(
                        territory,
                        this.state.brandAnalytics,
                        "tickets_opened"
                      )
                    )}
                    {this.renderItem(
                      BrandAnalytics(
                        territory,
                        this.state.brandAnalytics,
                        "tickets_closed"
                      )
                    )}
                    {this.renderItem(
                      BrandAnalytics(
                        territory,
                        this.state.brandAnalytics,
                        "user_referrals"
                      )
                    )}
                    {this.renderItem(
                      BrandAnalytics(
                        territory,
                        this.state.brandAnalytics,
                        "token_spending_marketplace"
                      )
                    )}
                  </div>
                </div>
                <div className="eco-analytics">
                  <div className="analytics-header">
                    <p style={{ marginRight: "20px" }}>
                      Total Ecosystem Figures
                    </p>
                    <div className="mode-btn-group">
                      <div
                        className={classnames("mode-toggle-btn", {
                          selected: ecoTab === 0,
                        })}
                        onClick={this.onTabChanged("ecoTab", 0)}
                      >
                        Total
                      </div>
                      <div
                        className={classnames("mode-toggle-btn", {
                          selected: ecoTab === 1,
                        })}
                      >
                        This month
                      </div>
                      <div
                        className={classnames("mode-toggle-btn", {
                          selected: brandTab === 2,
                        })}
                      >
                        Today
                      </div>
                    </div>
                  </div>
                  <div className="items-container">
                    {this.renderItem(EcoAnalytics(territory).active_users)}
                    {this.renderItem(EcoAnalytics(territory).verified_eco_ids)}
                    {this.renderItem(EcoAnalytics(territory).user_reviews)}
                    {this.renderItem(
                      EcoAnalytics(territory).active_open_banking
                    )}
                  </div>
                  <div className="items-container">
                    {this.renderItem(
                      EcoAnalytics(territory).token_value_earned
                    )}
                    {this.renderItem(
                      EcoAnalytics(territory).token_value_redeemed
                    )}
                    {this.renderItem(EcoAnalytics(territory).poll_answers)}
                    {this.renderItem(EcoAnalytics(territory).forum_engagement)}
                  </div>
                  <div className="items-container">
                    {this.renderItem(EcoAnalytics(territory).tickets_opened)}
                    {this.renderItem(EcoAnalytics(territory).tickets_closed)}
                    {this.renderItem(EcoAnalytics(territory).user_referrals)}
                    {this.renderItem(
                      EcoAnalytics(territory).token_spending_marketplace
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </main>
      </div>
    );
  }
}

export default Analytics;



// WEBPACK FOOTER //
// ./src/screens/Analytics/index.js